import {createCssVar} from '../theme'

export const TRANSITION_DURATION = 300

export const ALPHA_STEP = 0.025

export const [topOffset, setTopOffset] = createCssVar('topOffset', '0px')
